import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";
import { provideNzIconsPatch } from "ng-zorro-antd/icon";
import { LanguageServices } from "src/app/services/LanguageServices";
import { CheckCircleTwoTone, ThunderboltFill } from '@ant-design/icons-angular/icons';
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { FormulaTSService } from "src/app/services/formula-ts.service";
import { NZ_DRAWER_DATA } from "ng-zorro-antd/drawer";
import { NodeViewModel } from "../../webhook-interfaces/node";
import { FlowData } from "../../webhook-interfaces/flowdata";
import { KeyValue } from "@angular/common";
import { WebhookConfiguration, WebhookField, WebhookPanel, WebhookTab } from "../../webhook-interfaces/configuration";
import { FormServices } from "src/app/services/form.services";
import { ConnectorModel } from "../../webhook-interfaces/connectors";
import { WebHookCommonServices } from "../../webhook-services/webhook-commom.services";


@Component({
    selector: 'webhook-configuration',
    templateUrl: './webhook-edit-configuration.component.html',
    styleUrl: './webhook-edit-configuration.component.scss',
    standalone: false,
    providers: [provideNzIconsPatch([CheckCircleTwoTone,ThunderboltFill])]
})

export class WebhookEditConfigurationComponent implements OnInit, OnDestroy {
    panel: {id:string,name:string,active:boolean,disabled:boolean}[] = [];
    //formValidationList: {id:string, form:FormGroup<any>}[] =[]
    variables:Variable[] = [];
    node: NodeViewModel;
    connection:ConnectorModel;
    connections:ConnectorModel[] = [];
    nodes:NodeViewModel[] = [];
    flowData: FlowData;
    configuration:WebhookConfiguration =null;
    layoutMap: { [panelId: string]: any } = {};
    layoutMapPanel: { [tabId: string]: any } = {};
    tabs:WebhookTab[] = [];
    configurations:{name:string, layout:WebhookConfiguration}[] = [];
    createdError: boolean  = false;
    form:FormGroup;
    createdInputVariable: boolean;
    createdConditionalExecution: boolean;
    nodeToConnection:NodeViewModel;
    isNew:boolean = false;
    isConnection:boolean = false;

    editKey = false;
    keyName = null;

    constructor(
            private fb:NonNullableFormBuilder, 
            private fs:FormServices,
            @Inject(NZ_DRAWER_DATA) private data,
            private commomServices:WebHookCommonServices
        
        )  {
        
    }
    
    ngOnDestroy(): void {
        this.configurations = [];
        this.configuration = null;
        this.form = null;
    }

    getFieldsByPanelId(panelId:string){
        return this.configuration.fields.filter(data=>data.panel==panelId);
    }

    transformPanelMap(){
        this.panel.forEach(panel => {
            this.layoutMap[panel.id] = this.computeLayout(panel.id);
        });
    }

    transformTabMap(){
        this.tabs.forEach(tab => {
            this.layoutMapPanel[tab.id] = this.computeLayoutTab(tab.id);
        });
    }

    computeLayoutTab(tabId: string) {
       this.configuration.panels.sort((a,b)=>{
            if ( a.order > b.order ) { return 1;}
            if ( a.order < b.order ) { return -1;}
            return 0;

        });

        const grouped: { [id: string]: any[] } = {};
        let i = 0;
        for (const item of this.configuration.panels) {
            if (item.tab !== tabId) continue;
            let order = item.order==null? i++ : item.order;
            if (!grouped[order]) {
                grouped[order] = [];
            }

            grouped[order].push(item);
        }
        
        return grouped;
    }
    

    computeLayout(panelId: string) {
        const data = this.configuration.fields
            .filter(d => d.panel === panelId)
            .reduce((acc, item) => {
            acc[item.row] = acc[item.row] || [];
            acc[item.row].push(item);
            return acc;
            }, {} as { [row: number]: any[] });

        Object.keys(data).forEach(row => {
            data[+row].sort((a, b) => a.col - b.col);
        });
        
        return data;
    }


    initConfiguration(){
        this.configuration = JSON.parse(JSON.stringify(this.data.configuration));
        this.configurations = this.data.configurations;
    }

    ngOnInit(): void {
        
        this.node = this.data.node;
        this.nodes = this.data.nodes ?? [];         
        this.connections = this.data.connections ?? [];
        this.keyName = this.node?.key||this.connection?.key;
        this.connection = this.data.connection;
        this.flowData = this.data.flowData;
        //this.formValidationList = [];
        this.initVariables();
        this.initConfiguration();
        this.getTab();
        this.getPanel();
        this.getErrorPanel();
        this.getInputVariables();
        this.getConditionalExecution();
        this.transformTabMap();
        this.transformPanelMap();
        
        this.form =  this.fb.group({});
        this.panel.forEach(p=>{
            this.getFieldsByPanelId(p.id).forEach(each=>{
                this.commomServices.createControl(each,this.form);
            });
            //this.formValidationList.push({id:p.id,form:form});
        });
        if ( this.node!= null ){
            this.commomServices.refreshForms(this.node, this.form);
        }
        
        if ( this.connection!=null){
            this.nodeToConnection = this.data.nodeToConnection;
            this.commomServices.refreshForms(this.connection, this.form);
        }
    }
    
    
    getInputVariables() {
        if ( this.tabs.findIndex(d=>d.id=='inputVariable')>0 && !this.createdInputVariable ){
            this.createdInputVariable = true;

            let work= this.configurations.find(d=>d.name=="flow.form.inputVariable");
            this.configuration.panels.push(...work.layout.panels);
            this.configuration.fields.push(...work.layout.fields);
        }
    }

    getConditionalExecution() {
        if ( this.tabs.findIndex(d=>d.id=='conditionalExecution')>0 && !this.createdConditionalExecution ){
            this.createdConditionalExecution = true;

            let work= this.configurations.find(d=>d.name=="flow.form.conditionalExecution");
            this.configuration.panels.push(...work.layout.panels);
            this.configuration.fields.push(...work.layout.fields);
        }
    }
    

    getErrorPanel() {
        if ( this.tabs.findIndex(d=>d.id=='error')>0 && !this.createdError ){
            this.createdError = true;
            let work= this.configurations.find(d=>d.name=="flow.form.error");
            this.configuration.panels.push(...work.layout.panels);
            this.configuration.fields.push(...work.layout.fields);
        }
    }
    
    initVariables() {
        
        Object.keys(this.flowData).forEach(key=>{

            let val = this.flowData[key];
            if ( val instanceof Object){
                val = JSON.stringify(val);
            }
            if ( val instanceof Number){
                val = new String(val);
            }

            this.variables.push({

                key:"@"+key.toUpperCase(),
                value:val,
                type:"S"
            })
        })
    }

    

    getLayout(panelid:string) {
        var data =  this.configuration.fields.filter(d=>d.panel == panelid)
        .reduce((acc, item) => {
            acc[item.row] = acc[item.row] || [];
            acc[item.row].push(item);
            return acc;
        }, {} as { [row: number]: any[] });

        for (const row in data) {
            data[row].sort((a, b) => a.col - b.col);
        }

        return data;
    }
    
    getPanel(){
        this.panel =  this.configuration.panels;
    }

    getTab(){
        this.tabs =  this.configuration.tabs;
    }


    drawerWidth = 400;

    functionFieldtrackByFn( index: number, item) {
        return item.field;
    }

    functionTabletrackByFn(index,  item: KeyValue<string, any>) {
        return item.key;
    }

    private replaceKeyPrefix(id: string, oldKey: string, newKey: string): string {
        if (id === oldKey) return newKey;
        if (id.startsWith(oldKey + '_')) {
            return newKey + id.substring(oldKey.length);
        }
        return id;
    }

    changeKey(val:NodeViewModel,key){
         
        if (this.isConnection) return;

        const node: NodeViewModel = val;
        const oldKey = node.key;

        if (oldKey === key) return;   // nada a fazer

        node.outputs = (node.outputs ?? []).map(d => this.replaceKeyPrefix(d, oldKey, key));
        node.inputs  = (node.inputs  ?? []).map(d => this.replaceKeyPrefix(d, oldKey, key));

        (this.connections ?? []).forEach((conn, i) => {
            this.connections[i].from = this.replaceKeyPrefix(conn.from, oldKey, key);
            this.connections[i].to   = this.replaceKeyPrefix(conn.to,   oldKey, key);
        });

        (this.nodes ?? []).forEach((da, i) => {
            if (da.parentId === oldKey) {
                this.nodes[i].parentId = key;
            }
        });

        node.key = key;
        
    }

    
    onInputChange(val: string): void {
        this.keyName = val.replace(/[^a-zA-Z0-9_-]/g, '').toUpperCase();
    }

}
